import React from "react";
import { InputGroup } from "react-bootstrap";

export function Radio(props: any) {
  return <InputGroup.Radio {...props} />;
}
